module.exports = __webpack_public_path__ + "img/sack_right.6b7760f4.jpg";